var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "leasingTileContent", staticClass: "leasing" },
    [
      _c("table-title", [_vm._v("Лизинг")]),
      _vm._v(" "),
      _vm.auth
        ? [
            _vm.list.length
              ? [
                  _c(
                    "ul",
                    { staticClass: "leasing__list list" },
                    _vm._l(_vm.renderList, function (l, i) {
                      return _c("item", { key: i, attrs: { leasing: l } })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _vm.totalActive
                    ? _c("span", { staticClass: "leasing__count-message" }, [
                        _c("b", [
                          _vm._v(
                            "Общее количество действующих договоров лизинга:"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "count" }, [
                          _vm._v(_vm._s(_vm.totalActive)),
                        ]),
                      ])
                    : _vm._e(),
                ]
              : _c("p", { staticClass: "empty-message" }, [
                  _vm._v("Информация о лизингах отсутствует"),
                ]),
          ]
        : _c("demo-message"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }